import React, { useEffect, useState } from 'react'
import axios from 'axios'
import ViewNft from './ViewNft'
import "../styles/footer.css"
import Slider from "react-slick";
import blue from "../images/blue.jpg";
import green from "../images/green.jpg";
import dice from "../images/dice.png";
import lightBlue from "../images/light-blue.jpg";
import "../styles/Nftcategory.css"
import { useDispatch, useSelector } from "react-redux";
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import Web3 from "web3";

import { WalletLinkConnector } from "@web3-react/walletlink-connector";
import { WalletConnectConnector } from "@web3-react/walletconnect-connector";
import { InjectedConnector } from "@web3-react/injected-connector";
import { useWeb3React } from "@web3-react/core";

import token from "../constants/erc20.json";
import holder from "../constants/holder.json";
import NFT from "../constants/NFT.json";
import address from "../utils/output.json";
// import reward from "../constants/reward.json";
import PoolGame from "./games/Pool"

// import { sendNFTRewards, sendTokenRewards, DrawNFT, DrawTokens }  from "../utils/web3Connection";

import { getNFT } from "../store/action";
// import "./App.css";

const CoinbaseWallet = new WalletLinkConnector({
  url: `https://mainnet.infura.io/v3/${process.env.INFURA_KEY}`,
  appName: "Web3-react Demo",
  supportedChainIds: [1, 3, 4, 5, 42],
});

const WalletConnect = new WalletConnectConnector({
  rpcUrl: `https://mainnet.infura.io/v3/${process.env.INFURA_KEY}`,
  bridge: "https://bridge.walletconnect.org",
  qrcode: true,
});

const Injected = new InjectedConnector({
  supportedChainIds: [1, 3, 4, 5, 42],
});

const PayNft = (props) => {

  const paymentnft = useSelector((state) => state.paymentnft);
  const [product, setProduct] = useState([]);

  // useEffect(() => {
  //   props.getNFT();
  //   if(paymentnft.nftData!=null && paymentnft.nftData.length > 0){
  //     setProduct(paymentnft.nftData)
  //   }
  // }, [])
  // paymentnft.nftData

  useEffect(() =>{
    props.getNFT();
    walletNFT()
  },[])

  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    speed: 2000,
    autoplaySpeed: 3000,
    slidesToShow: 1.7,
    slidesToScroll: 1
  }


  const [rewardAmount, SetrewardAmount] = useState("empty");
  const [amountofNFT, setAmountofNFT] = useState({}); //number of nft to mint
  const onChangeInput = e => {
    const { name, value } = e.target;
    setAmountofNFT({ ...amountofNFT, [name]: value })
  }

  const [nftID, setNftId] = useState("");   //nftid for stake
  const [nftdata, setNftdata] = useState([]);
  const [tokenbalance, setTokenBalance] = useState(""); //show token balance
  const [stakedNFT, setStakedNFT] = useState(""); //show staked nft id
  const [stakedtoken, setStakedToken] = useState(""); //show staked token
  const [tokenAmountToStake, setTokenAmountoStake] = useState(0.0001); //set amount of tokens to staked

  //---------------------------//
  const [stakeToken,setstakeToken] = useState('0x3F1a7192A9D731f827F7dB1D7c2892bac6FD9080')
  const [approval,setApproval] = useState('')
  

  //address for user to win or loose
  const [winneraddress, setwinnerAddress] = useState(""); //
  const [looseraddress, setlooserAddress] = useState(""); //

  //allow user to stake nft with required id
  const stakeNFt = async () => {
    const provider = await Injected.activate();
    const web3 = new Web3(provider.provider);
    const NFTobj = new web3.eth.Contract(NFT.abi, address.NFT);
    const holderobj = new web3.eth.Contract(holder, address.holder);
    const account = await web3.eth.getAccounts();
    console.log("account", account);
    const tx1 = {
      from: account[0],
      to: address.NFT,
    };
    let approval = await NFTobj.methods
      .setApprovalForAll(address.holder, true)
      .send(tx1);
    let tx2 = {
      from: account[0],
      to: address.holder,
    };

    console.log(approval);
    setstakeToken(approval.from)
    let stake = await holderobj.methods.StakeNFt(nftID).send(tx2);
    console.log({stake});
  };

  // const MintNFT = async (_amount) => {
  //   const provider = await Injected.activate();
  //   const web3 = new Web3(provider.provider);
  //   const NFTobj = new web3.eth.Contract(NFT.abi, address.NFT);
  //   const account = await web3.eth.getAccounts();
  //   console.log(amountofNFT);
  //   let amount = await NFTobj.methods.cost.call().call();
  //   console.log(amount);
  //   console.log(this.amountofNFT)

  //   let tx = {
  //     from: account[0],
  //     to: address.NFT,
  //     value: amount,
  //   };

  //   let mintres = await NFTobj.methods.mint(parseInt(amountofNFT)).send(tx);
  //   console.log(mintres);
  // };

  
  //it fetch the amount of nft and hold by the wallet with metadata to show on frontend
  const walletNFT = async () => {
    const provider = await Injected.activate();
    const web3 = new Web3(provider.provider);
    const NFTobj = new web3.eth.Contract(NFT.abi, address.NFT);
    // const holderobj = new web3.eth.Contract(holder.abi, address.holder);
    const account = await web3.eth.getAccounts();
    const values = await NFTobj.methods.walletOfOwner(account[0]).call();
    console.log(values);
    const NFTData = [];
    const data = await values.map(async (id) => {
      NFTData.push(await NFTobj.methods.tokenURI(id).call());
    });
    console.log({NFTData});
    setNftdata(NFTData);
  };

  //it shows the rewards of addresses

  // const rewards = async () => {
  //   const provider = await Injected.activate();
  //   const web3 = new Web3(provider.provider);
  //   const rewards = new web3.eth.Contract(reward, address.distributer);
  //   const account = await web3.eth.getAccounts();
  //   const amount = await rewards.methods.showrewards(account[0]).call();
  //   console.log(amount);
  //   SetrewardAmount(amount);
  // };

  //allow user to claim the rewards
  // const claimRewards = async () => {
  //   const provider = await Injected.activate();
  //   const web3 = new Web3(provider.provider);
  //   const rewards = new web3.eth.Contract(reward, address.distributer);
  //   const account = await web3.eth.getAccounts();
  //   const tx = {
  //     from: account[0],
  //   }
  //   const amount = await rewards.methods.claimReward().send(tx);
  //   console.log(amount);
  //   SetrewardAmount(rewards);
  // };

  //distribute the rewards NFT

  // const rewardDistributorNFT = async () => {
  //   const results = await sendNFTRewards(winneraddress, looseraddress);
  //   console.log(results);
  // }
  //distribute the rewards Token ESP
  // const rewardDistributorToken = async () => {
  //   const results = await sendTokenRewards(winneraddress, looseraddress);
  //   console.log(results);
  // }
  
  //show token balance
  const tokenBalance = async () => {
    const provider = await Injected.activate();
    const web3 = new Web3(provider.provider);
    const rewards = new web3.eth.Contract(token.abi, address.Token);
    const account = await web3.eth.getAccounts();
    const amount = await rewards.methods.balanceOf(account[0]).call();
    console.log(amount);
    setTokenBalance(amount);
  };
  //show staked NFT
  const StakedNFT = async () => {
    const provider = await Injected.activate();
    const web3 = new Web3(provider.provider);
    const holderobj = new web3.eth.Contract(holder, address.holder);
    const account = await web3.eth.getAccounts();
    const nftID = await holderobj.methods.checkStatusNFT(account[0]).call();
    if (parseInt(nftID) != 0) {
      setStakedNFT(nftID);
    } else {
      setStakedNFT("No nft staked");
    }
  }
  //show staked token balance

  const tokenStakedAmount = async () => {
    const provider = await Injected.activate();
    const web3 = new Web3(provider.provider);
    const holderobj = new web3.eth.Contract(holder, address.holder);
    const account = await web3.eth.getAccounts();
    const nftID = await holderobj.methods.stakedAmount(account[0]).call();
    setStakedToken(nftID);

  }
  //stake tokens for game

  const stakeTokens = async () => {
    const provider = await Injected.activate();
    const web3 = new Web3(provider.provider);
    const tokenobj = new web3.eth.Contract(token.abi, address.Token);
    const holderobj = new web3.eth.Contract(holder, address.holder);
    const account = await web3.eth.getAccounts();
    console.log("working", account);
    const tx1 = {
      from: account[0],
      to: address.NFT,
    };
    let approval = await tokenobj.methods
      .approve(address.holder, Web3.utils.toWei(tokenAmountToStake))
      .send(tx1);
    let tx2 = {
      from: account[0],
      to: address.holder,
    };

    console.log(approval);
    setApproval(approval)
    let stake = await holderobj.methods.EnterStake(Web3.utils.toWei(tokenAmountToStake + "", 'ether')).send(tx2);
    console.log(stake);
  };
  //draw match return NFT
  // const drawNFTback = async () => {
  //   const results = await DrawNFT(winneraddress, looseraddress) // here wimnner looser address are just for returning both nft back
  // }

  //draw match return Tokens ESP
  // const drawTokensback = async () => {
  //   const results = await DrawTokens(winneraddress, looseraddress) // here wimnner looser address are just for returning both nft back
  // }

  const { active, chainId, account } = useWeb3React();

  const { activate, deactivate } = useWeb3React();


  return (

    <div>

      <div className='pro prduct-container' >
        {/* {
          nftdata != null ? (
            nftdata.map(pro => {
              console.log({pro});
              return (
                <div>               
                  <ViewNft product={pro} key={pro.id} />
                </div>
              )
            })
            
          ) : (
            <div className='text-center mt-5 text-light'>

              <h2>There is no Nft</h2>
            </div>
          )
         
        } */}




{/* {
   nftdata.map(nft =>{
    return(
      <div>
         
        <ViewNft product={nft} key={nft.id} />
        console.log({nft});
      </div>
    )
  })
} */}

      </div>
      {

 <div>
<PoolGame token={stakeToken} />
</div>

    // approval ? (
    //   <div>
    //   <PoolGame token={stakeToken} />
    //   </div>
    // ):(
    //   <div>
    //     not Approved
    //   </div>
    // )
   
   
}
      <div className="text-light   mt-5">
        <Slider {...settings}>
          <div className="d-flex justify-content-center" >
            <div className=" position-relative">
              <div className="row">
                <div className="col-6">
                  <img src={blue} className="slider-img-1 "></img>
                </div>
              </div>
              <div className="position-absolute card-pos row" onClick={stakeTokens}>
                <div className="row">
                  <div className="col-6">
                    <h2>DOWNTOWN</h2>
                    <h2>LONDON</h2>
                  </div>
                </div>
                <div className="mt-4">
                  <div className="d-flex justify-content-center prize">
                    <h2 className="">STAKE_TOKEN :</h2>
                    <input
                      type="text"
                      name="amount1"
                      id="amount1"
                      aria-label="amount1"
                      value="50"
                      onChange={(event) => setTokenAmountoStake(event.target.value)}
                    disabled></input>
                  </div>
                </div>
                <div className="d-flex justify-content-center">
                  <h3>Standard</h3>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="d-flex justify-content-center" onClick={stakeNFt}>
              <div className=" position-relative">
                <div className="row">
                  <div className="col-6">
                    <img src={green} className="slider-img-1 "></img>
                  </div>
                </div>
                <div className="position-absolute card-pos row">
                  <div className="row">
                    <div className="col-6">
                      <h2>LIVERPOOL</h2>
                      <h2>AUSTRALIA</h2>
                    </div>
                  </div>
                  <div className="mt-4">
                    <div className="d-flex justify-content-center prize">
                      <h2 className="">STAKE_TOKEN :</h2>
                      <input
                        type="text"
                        name="amount2"
                        id="amount2"
                        aria-label="amount2"
                        placeholder='NFT ID'
                        onChange={(event) => setNftId(event.target.value)}
                      ></input>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center">
                    <h3>Standard</h3>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* <div> */}
            {/* <div className="d-flex justify-content-center" >
              <div className=" position-relative">
                <div className="row">
                  <div className="col-6">
                    <img src={lightBlue} className="slider-img-1 "></img>
                  </div>
                </div>
                <div className="position-absolute card-pos row">
                  <div className="row">
                    <div className="col-6">
                      <h2>SYDNEY</h2>
                      <h2>LONDON</h2>
                    </div> */}
                    {/* <div className="col-6">
                  <img src={dice} className="slider-img-2" width="100px" height="50px"/>

                  </div> */}
                  {/* </div>
                  <div className="mt-4">
                    <div className="d-flex justify-content-center prize">
                      <h1 className="">PRIZE : 150</h1>
                    </div>
                  </div>
                  <div className="d-flex justify-content-center">

                    <h3>Standard</h3>
                  </div>

                </div>
              </div>
            </div>
          </div> */}
          {/* <div>
            <h3>4</h3>
          </div> */}
          {/* <div>
            <h3>5</h3>
          </div>
          <div>
            <h3>6</h3>
          </div> */}
        </Slider>
      </div>

    </div>

  )
}

const mapStateToProps = state => {
  const { paymentnft, auth} = state
  return { paymentnft, auth }
}

export default connect(mapStateToProps, { getNFT })(PayNft)


PayNft.propTypes = {
  errorMsg: PropTypes.any,
  nftData: PropTypes.any,
  history: PropTypes.object,
  // stakeToken: PropTypes.any
  
}
// export default PayNft;
